import { Box, Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import TableListData from "../components/FormBuilder/subcomponents/TableListData";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import Navbar from "../components/Navbar";
import { getAllPublishTemplates } from "../redux/entities/formBuilderEntity";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const PublishTemplateListPage = () => {
  const listData = useAppSelector((state) => state.entities.formBuilder.getAllPublishTemplates);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [searchString, setSearchString] = useState(""); // State for search
  const [page, setPage] = useState(0); // State for page
  const [rowsPerPage, setRowsPerPage] = useState(5); // State for rows per page

  // Fetch templates whenever searchString, page or rowsPerPage changes
  useEffect(() => {
    dispatch(getAllPublishTemplates({ searchString, page: setPage, limit: rowsPerPage }));
  }, [dispatch, searchString, page, rowsPerPage]);

  // Handle search change
  const handleSearch = (e) => {
    setSearchString(e.target.value);
    setPage(0); // Reset to the first page when search is updated
  };

  // Handle page change
  const handleChangePage = (newPage) => {
    setPage(newPage); // Set the new page number
  };

  // Handle change in rows per page
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10)); // Set rows per page
    setPage(0); // Reset to the first page when rows per page change
  };

  async function deleteTemplate(id) {
    try {
      Swal.fire({
        text: "Are you sure, You want to delete template?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#5149E4",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const token = localStorage.getItem("userToken");
            const headers = { Authorization: `Bearer ${token}` };
            const response = await axios.delete(`${API_BASE_URL}/templates/${id}`, { headers });
            if (response?.data?.status === "SUCCESS") {
              Swal.fire({ text: response?.data?.message, icon: "success" })
              await dispatch(getAllPublishTemplates({ searchString, page: page + 1, limit: rowsPerPage }));
            } else if (response?.data?.status === "JWT_INVALID") {
              Swal.fire({ text: response?.data?.message, icon: "warning" })
              navigate("/");
            } else {
              Swal.fire({ text: response?.data?.message, icon: "warning" })
            }
          } catch (error) {
            Swal.fire({ text: error?.message, icon: "warning", })
          }

        }
      });
    } catch (error) {
      Swal.fire({ text: error?.message, icon: "warning", })
    }
  }

  async function changeTemplateStatus(id) {
    try {
      Swal.fire({
        text: "Are you sure, You want to change the status of template?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#5149E4",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const token = localStorage.getItem("userToken");
            const response = await axios.put(`${API_BASE_URL}/templates/activeDeactive/${id}`, {}, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data.status === "SUCCESS") {
              Swal.fire({ text: response?.data?.message, icon: "success" })
              await dispatch(getAllPublishTemplates({ searchString, page: page + 1, limit: rowsPerPage }));
            } else if (response?.data?.status === "JWT_INVALID") {
              Swal.fire({ text: response?.data?.message, icon: "warning" })
              navigate("/");
            } else {
              Swal.fire({ text: response?.data?.message, icon: "warning" })
            }
          } catch (error) {
            Swal.fire({ text: error?.message, icon: "warning", })
          }

        }
      });
    } catch (error) {
      Swal.fire({ text: error?.message, icon: "warning", })
    }
  }

  async function handleGenerateSchoolCode(template) {
    try {

      Swal.fire({
        text: "Are you sure, You want to generate school code?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#5149E4",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const token = localStorage.getItem("userToken");
            const headers = { Authorization: `Bearer ${token}` };
            const response = await axios.post(`${API_BASE_URL}/generate-school-code`, { formId: template?._id }, { headers });
            if (response?.data?.status === "SUCCESS") {
              Swal.fire({ text: response?.data?.message, icon: "success" })
              await dispatch(getAllPublishTemplates({ }));
            } else if (response?.data?.status === "JWT_INVALID") {
              Swal.fire({ text: response?.data?.message, icon: "warning" })
              navigate("/");
            } else {
              Swal.fire({ text: response?.data?.message, icon: "warning" })
            }
          } catch (error) {
            Swal.fire({ text: error?.message, icon: "warning", })
          }

        }
      });

    } catch (error) {
      Swal.fire({ text: error?.message, icon: "warning", })
    }
  }

  return (
    <>
      <Navbar />
      <div className="d-flex mt-2 flex-column align-items-center justify-content-center">
        <h3>Publish Template List</h3>
        <div className="d-flex justify-content-between w-100" style={{ marginLeft: "40px" }}>
          <input
            type="text"
            value={searchString}
            onChange={handleSearch} // Update searchString on change
            placeholder="Search templates"
            style={{ width: "250px", padding: "5px", fontSize: "14px", borderRadius: "4px" }}
          />
        </div>
        <div className="form-templates row mt-1"></div>
        <Box sx={{ width: "100%" }}>
          <Card sx={{ p: 2 }}>
            <TableListData
              data={listData} // List of templates
              searchString={searchString} // Search string from the parent component
              page={page} // Current page
              setPage={handleChangePage} // Function to update the page
              rowsPerPage={rowsPerPage} // Number of rows per page
              setRowsPerPage={handleChangeRowsPerPage} // Function to update rows per page
              deleteTemplate={deleteTemplate}
              changeTemplateStatus={changeTemplateStatus}
              handleGenerateSchoolCode={handleGenerateSchoolCode}
            />
          </Card>
        </Box>
      </div>
    </>
  );
};

export default PublishTemplateListPage;
